/* MimosPets: garantiza el scroll a anclas (#comprar) en todos los navegadores.
   Cubre: carga de página con ancla en la URL, clicks en enlaces internos
   (aunque el hash no cambie) y cambios de hash. */
(function () {
  function scrollToHash(hash) {
    if (!hash || hash.length < 2) return false;
    var el;
    try {
      el = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (e) {
      return false;
    }
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // Si tras la animación el ancla sigue lejos (navegadores/entornos que
    // bloquean el scroll suave), saltar directo forzando scroll instantáneo
    setTimeout(function () {
      if (Math.abs(el.getBoundingClientRect().top) > 100) {
        var html = document.documentElement;
        var prev = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        el.scrollIntoView({ behavior: 'instant', block: 'start' });
        html.style.scrollBehavior = prev;
      }
    }, 800);
    return true;
  }

  // Carga inicial con ancla en la URL (p. ej. desde el menú)
  window.addEventListener('load', function () {
    if (window.location.hash) {
      setTimeout(function () {
        scrollToHash(window.location.hash);
      }, 100);
    }
  });

  // Clicks en enlaces internos de la misma página (funciona aunque el hash no cambie)
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link) return;
    var url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname || url.hostname !== window.location.hostname) return;
    if (scrollToHash(url.hash)) {
      event.preventDefault();
      if (window.location.hash !== url.hash) {
        history.pushState(null, '', url.hash);
      }
    }
  });

  window.addEventListener('hashchange', function () {
    scrollToHash(window.location.hash);
  });
})();
